var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex bars-chart",staticStyle:{"height":"100%","width":"'100%"}},[(_vm.waiting)?_c('v-skeleton-loader',{attrs:{"width":'100%',"height":'80%',"type":"image"}}):_c('v-chart',{attrs:{"autoresize":"","option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }